'use strict';

exports.__esModule = true;

var _locale = require('element-ui/lib/locale');

exports.default = {
  methods: {
    t: function t() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _locale.t.apply(this, args);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/_element-ui@2.15.1@element-ui/lib/mixins/locale.js
// module id = w12Q
// module chunks = 0